<div class="row">
  <div class="col-12">

    <p>For your security, please choose one of the options to verify your identity and provide the
      other requested information.</p>

    <div class="form-group form-label-select-group">
      <select id="confirmationCodeDeliveryMethod" class="form-control" [(ngModel)]="confirmationCodeDeliveryMethod" (change)='onOtpOptionSelected()'>
        <option [ngValue]="null" disabled selected>Confirmation Code Delivery Method</option>
        <option [ngValue]="'emailMe'">Email Me</option>
        <option [ngValue]="'textMe'">Text Me</option>
      </select>
      <label for="confirmationCodeDeliveryMethod">Confirmation Code Delivery Method</label>
    </div>

    <div *ngIf="!genericErrorAlertShown && confirmationCodeDeliveryMethod == 'emailMe'" [@showResetPasswordByEmailWindow]>
      <app-send-confirmation-code-by-email>
      </app-send-confirmation-code-by-email>
    </div>

    <div *ngIf="!genericErrorAlertShown && confirmationCodeDeliveryMethod == 'textMe'" [@showResetPasswordByPhoneWindow]>
      <app-send-confirmation-code-by-phone>
      </app-send-confirmation-code-by-phone>
    </div>

    <div id="genericErrorAlert" class="alert alert-danger mb-4 py-4" role="alert"
         *ngIf="genericErrorAlertShown" [@showGenericErrorAlert]>
      <p>We encountered an issue completing your request.</p>
      <span>Please try again later or contact Customer Service at {{ customerServicePhone }}.</span>
    </div>

  </div>
</div>
